import {useContext} from "react";
import { UserContext } from '../Context/UserContext';
import "../styles/picks.css"

function PickResults ({articles}) {
    const {state} = useContext(UserContext);
    const today = new Date()
    //console.log('today', today)
    const yesterday = new Date(today - 86400000)
    const month = yesterday.getMonth()
    const monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    const yesterdayFormat = `${monthNames[month]} ${yesterday.getDate()}`;
    //console.log('articles', articles)
    const createdDates = articles.map(art => new Date(art.created_at))
    //console.log('createdDates', createdDates)
    const record = ""
    const noPicks = () =>  {
        //check if any dates in createdDates === yesterday
        const filteredArticles = createdDates.filter((date) => {
            const dateFormat = String(date).slice(0,15)
            const yesterdayComp = String(yesterday).slice(0,15)
            return dateFormat === yesterdayComp
        })
        //if not, return no Picks
        if (filteredArticles.length === 0) {
            return "No Picks"
        }
        else return record
    }
    
    function renderUnits(units) {
        return units > 0 ? `+${units}` : `${units}`
    }

    return (
        <div className="pickResults">
            <h3>2026 Results</h3>
            {/* <p>{yesterdayFormat}: {noPicks()}</p> */}
            <div className="pickNames">
                {/* <p id="overallRecords">Overall:</p> */}
                {state.authorsAndResults.map((obj) => {
                    return (
                        <p key={obj.author.id} className="pickNamesAndLogos">{obj.author.first_name} {obj.author.last_name}: {obj.record.wins}-{obj.record.losses} {renderUnits(obj.record.units)} units
                            <a href={`https://twitter.com/${obj.author.twitter_handle}`} target="_blank" rel='noreferrer'>
                                <img className="twitterLogo" src="https://cdn1.iconfinder.com/data/icons/logotypes/32/twitter-512.png" alt=""/>
                            </a>
                        </p>
                    )
                })}
            </div>
        </div>
    )
}

export default PickResults